import { FileDescriptor } from '@servicetitan/form';

export enum UploadErrorType {
    FileSizeError,
    FileNumberError,
    FileTypeError,
}

export const getFileName = (file: File | string) => {
    if (typeof file === 'string') {
        return file.slice(file.lastIndexOf('/') + 1);
    }
    return file.name;
};

export const isFileSizeValid = (file: File, sizeLimit: number) => {
    return file.size / (1024 * 1024) > sizeLimit;
};

export const getOverSizedFiles = (files: FileDescriptor[], size: number) => {
    const filesOverLimit: FileDescriptor[] = [];
    for (const file of files) {
        if (typeof file.file !== 'string') {
            if (isFileSizeValid(file.file, size)) {
                filesOverLimit.push(file);
            }
        }
    }
    return filesOverLimit;
};

export const validateFiles = (
    newFiles: FileDescriptor[],
    sizeLimitInMb: number,
    countLimit: number,
    allowedFileTypes?: string[]
) => {
    const filesOverLimit: FileDescriptor[] = getOverSizedFiles(newFiles, sizeLimitInMb);
    let fileUploadError = '';

    let errorType: UploadErrorType | undefined = undefined;

    if (newFiles.length === 1 && filesOverLimit.length) {
        fileUploadError = `File is too large and cannot be attached. Maximum file size is ${sizeLimitInMb} MB.`;
        errorType = UploadErrorType.FileSizeError;
    } else if (newFiles.length > 1 && filesOverLimit.length) {
        errorType = UploadErrorType.FileSizeError;
        fileUploadError = `Some files were not attached.  Maximum file size is ${sizeLimitInMb} MB.`;
    }

    let files: FileDescriptor[] = newFiles.filter(f => filesOverLimit.indexOf(f) < 0);

    if (files.length > countLimit) {
        files = files.slice(0, countLimit);
        fileUploadError = `Some files were not attached. Only ${countLimit} files can be added.`;
        errorType = UploadErrorType.FileNumberError;
    }

    if (allowedFileTypes?.length && files.length) {
        const filesWithValidTypes = files.filter(f => {
            const name = ((f.file as any).name as string) ?? f.file;
            return allowedFileTypes.find(type => name.endsWith(type));
        });
        if (filesWithValidTypes.length !== files.length) {
            fileUploadError = 'Some files were not attached. File format is not supported.';
            errorType = UploadErrorType.FileTypeError;
            files = filesWithValidTypes;
        }
    }

    return {
        files,
        errorType,
        hasError: !!fileUploadError,
        error: fileUploadError,
    };
};

const commonUploadableFileTypes = ['.csv', '.xls', '.xlsx', '.pdf'];

export const priceBookUploadableFileTypes = [
    ...commonUploadableFileTypes,
    '.jpg',
    '.jpeg',
    '.png',
    '.webp',
    '.bmp',
    '.gif',
    '.mp4',
    '.zip',
    '.rar',
];

export const telecomUploadableFileTypes = [...commonUploadableFileTypes, '.jpg', '.tiff', '.png'];
